import {Component} from 'intact';
import template from './index.vdt';

export class Blockquote extends Component {
    static template = template;
}
